import { Table, TableBody, TableCell, TableColumn, TableHeader, TableRow, } from "@nextui-org/react";
import { useAuth, useFirestore, useFirestoreCollectionData, useUser } from "reactfire";
import { collection, where, query, getDocs, onSnapshot, orderBy } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { NewExtractor } from "./newExtractor";
import { useEffect, useState } from "react";
import { get } from "firebase/database";

const Extractors = () => {
    const auth = useAuth();
    const navigate = useNavigate(); 
    const firestore = useFirestore();

    const [extractors, setExtractors] = useState<any[]>([]);
   
    const dateFormatter = new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
    });

    useEffect(()=>{
        const fetchData = async () => {
            
            if (auth.currentUser) {
                const q = query(collection(firestore, "extractors"), where("createdBy", "==", auth.currentUser?.uid), orderBy('lastUpdated', 'desc'));

                const unsubscribe = onSnapshot(q, (querySnapshot) => {
                    const docs:Array<any> = [];
                    querySnapshot.forEach((doc) => {
                        docs.push({ ...doc.data(), id: doc.id });
                    });
                    setExtractors(docs);
                });
            }
        }
        fetchData(); 
    }, []);

    return (
        <>
            <div className="flex justify-between">
                <div className="text-2xl font-bold">Extractors</div>
                <NewExtractor />
            </div>
            <br></br>
            <Table
                aria-label="Extractors"
                selectionMode="single"
            >
                <TableHeader>
                    <TableColumn>Name</TableColumn>
                    <TableColumn>Description</TableColumn>
                    <TableColumn>Created By</TableColumn>
                    <TableColumn>Last Updated</TableColumn>
                </TableHeader>
                <TableBody 
                    emptyContent={"No rows to display"}>
                    {extractors?.map((extractor: any) => (
                        //TODO: paginated table 
                        
                        <TableRow key={extractor.id} onClick={()=>navigate(`/extractor/${extractor.id}`)}>
                            <TableCell>{extractor.name}</TableCell>
                            <TableCell>{extractor.description}</TableCell>
                            <TableCell>{extractor.createdByName}</TableCell>
                            <TableCell>{dateFormatter.format(new Date(extractor.lastUpdated))}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </>
    )
}


export default Extractors; 